import { useEffect } from "react";

export default function Cursor() {
  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;

    const el = document.createElement("div");
    el.id = "cursor";
    document.body.appendChild(el);

    const move = (e) => {
      el.style.left = e.clientX + "px";
      el.style.top = e.clientY + "px";
    };
    const add = () => el.classList.add("hover");
    const remove = () => el.classList.remove("hover");

    window.addEventListener("mousemove", move);

    // Delegate hover detection
    const onOver = (e) => {
      if (
        e.target.closest(
          "a, button, .post-card, .tag-btn, .popular-item, .featured-post, input, textarea"
        )
      ) {
        add();
      }
    };
    const onOut = (e) => {
      if (
        e.target.closest(
          "a, button, .post-card, .tag-btn, .popular-item, .featured-post, input, textarea"
        )
      ) {
        remove();
      }
    };
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseout", onOut);

    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseout", onOut);
      el.remove();
    };
  }, []);

  return null;
}
